// Header

const Header = () => {

    return (
    <header id="header">
        <h1><span className="lower">S</span>t<span className="upper">ar</span>s Align</h1>
    </header>
    )
}

export default Header;